module.exports = __webpack_public_path__ + "img/group-logotype-white.5ef0d911.svg";